<ng-container *ngIf="viewModel$ | async as viewModel">
    <ms-dropdown
        #dropdown
        class="system-bet-bar-dropdown"
        viewport="bs-digital-system-bet-bar"
        dropdownPlacement="left"
        popperClass="dropdown-popper,system-bet-bar-dropdown-content"
        [titleTemplate]="titleTemplate"
        [optionTemplate]="optionTemplate"
        [activeOption]="viewModel.selectedOption"
        [options]="viewModel.options"
        (optionChange)="onOptionSelected($event)"></ms-dropdown>
    <div class="system-bet-bar-banker">
        <span class="system-bet-bar-banker-label">{{ messages.common.Banker }}</span>
        <button class="system-bet-bar-banker-btn" [class.selected]="viewModel.isBankerActive" (click)="toggleBanker()">
            {{ messages.common.BankerAbbr }}
        </button>
        <span class="system-bet-bar-banker-info" (click)="toggleBankerHelp()">
            <i class="system-bet-bar-banker-icon theme-info"></i>
        </span>
    </div>
    <ng-template #titleTemplate let-title>
        <span class="system-bet-bar-dropdown-title">{{ title }}</span>
    </ng-template>

    <ng-template #optionTemplate let-option>
        <div class="system-bet-bar-dropdown-option" *ngIf="viewModel.selectedOption.id !== option.id" (click)="dropdown.selectOption(option)">
            <span>{{ option.name }}</span>
            <span class="system-bet-bar-dropdown-betcount" *ngIf="option.payload">{{ getBetCount(option.payload.betCount) }}</span>
        </div>
    </ng-template>

    <bs-info-message-container [messageId]="bankerHelpMessageId">
        <bs-digital-betslip-info [messages]="betslipInfoMessage" (close)="toggleBankerHelp()"> </bs-digital-betslip-info>
    </bs-info-message-container>
</ng-container>
